<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <table style="width:100%">
        <tr>
            <!-- <td>
                <v-chip label>{{item.name}}</v-chip>
            </td> -->
            <td>
                <v-container fluid class="pa-0">
                    <v-row dense>                
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <NumInput 
                                v-model="shipment" 
                                clearable
                                :suffix="item.data.unit != null ? item.data.unit : ''"
                                :label="item.name+'出荷'" 
                                outlined
                                hide-details 
                                dense
                                :canEdit="canEdit"
                                align="align-left" />
                        </v-col>
                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                            <NumInput 
                                v-model="sales" 
                                clearable
                                :suffix="item.data.unit != null ? item.data.unit : ''"
                                :label="item.name+'販売'" 
                                outlined
                                hide-details 
                                dense
                                :canEdit="canEdit"
                                align="align-left" />
                        </v-col>
                    </v-row>
                </v-container>    
            </td>
        </tr>
    </table>
</template>

<script>
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    export default {
        components: {
            NumInput
        },
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        shipment: "0",
                        sales: "0"
                    }
                }
            },
            /** 作業記録項目種類 */
            item: null,
            /** 編集可否 */
            canEdit: false,
        },
        data: function () {
            return {
                shipment: 0,
                sales: 0
            }
        },
        computed: {
            editValue: {
                get: function () {
                    return this.$props.value
                },
                set: function (v) {
                    this.$emit("input", v)
                }
            },
        },
        watch: {
            /**
             * 出荷数の監視
             * 値が変更された時に、"出荷と販売" の値(オブジェクト)にセット
             */
            shipment: function (value, old) {
                this.value.shipment = value
            },
            /**
             * 販売数の監視
             * 値が変更された時に、"出荷と販売" の値(オブジェクト)にセット
             */
            sales: function (value, old) {
                this.value.sales = value
            }
        },
        created: function () {
            console.log("PlaceWorkRecorderShipmentAndSales", "created", this.editValue)
            if (this.editValue == "") {
                this.editValue = {
                    shipment: "0",
                    sales: "0"
                }
            }
            this.shipment = this.editValue.shipment
            this.sales = this.editValue.sales
        }
    }
</script>
